import { UTCDate } from '@date-fns/utc';

export const getFormattedDateString = (
  date: UTCDate | Date | string | null | undefined,
  granularity: 'week' | 'month'
): string => {
  if (!date) {
    return '';
  }

  const dateObj = typeof date === 'string' ? new UTCDate(date) : date;

  const formatString = granularity === 'week' ? 'yyyy-MM-dd' : 'yyyy-MM';
  const formatLen = formatString.length;

  try {
    return dateObj.toISOString().slice(0, formatLen);
  } catch (error) {
    console.error('Error formatting date:', date, error);
    return '';
  }
};

export const localToUTC = (date: Date | null) => {
  if (!date) {
    return null;
  }

  return new UTCDate(date.getFullYear(), date.getMonth(), date.getDate());
};

export const utcToLocal = (
  utcDate: UTCDate | null | undefined
): Date | null => {
  if (!utcDate) {
    return null;
  }

  return new Date(
    utcDate.getUTCFullYear(),
    utcDate.getUTCMonth(),
    utcDate.getUTCDate()
  );
};
